// Generated from /Users/niket/Developer/0.0.TestProjects/4.0.Antlr/FiltersV1/src/Filters.g4 by ANTLR 4.7
// jshint ignore: start
/* eslint-disable */
var antlr4 = require('antlr4/index');
var FiltersListener = require('./FiltersListener').FiltersListener;
var grammarFileName = 'Filters.g4';

var serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964',
  '\u0003&\u00d3\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t',
  '\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004',
  '\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004',
  '\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004',
  '\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t',
  '\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004',
  '\u0018\t\u0018\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003',
  '\u0003\u0003\u0003\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003',
  '\u0004\u0003\u0004\u0007\u0004=\n\u0004\f\u0004\u000e\u0004@\u000b\u0004',
  '\u0003\u0004\u0003\u0004\u0003\u0005\u0005\u0005E\n\u0005\u0003\u0005',
  '\u0003\u0005\u0005\u0005I\n\u0005\u0003\u0006\u0003\u0006\u0003\u0006',
  '\u0003\u0006\u0005\u0006O\n\u0006\u0003\u0007\u0003\u0007\u0003\u0007',
  '\u0003\u0007\u0007\u0007U\n\u0007\f\u0007\u000e\u0007X\u000b\u0007\u0003',
  '\b\u0003\b\u0007\b\\\n\b\f\b\u000e\b_\u000b\b\u0003\t\u0003\t\u0003',
  '\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0005\tj\n\t\u0003',
  '\n\u0003\n\u0003\n\u0003\n\u0007\np\n\n\f\n\u000e\ns\u000b\n\u0003\u000b',
  '\u0003\u000b\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0005\f{\n\f\u0003',
  '\f\u0003\f\u0003\f\u0003\r\u0003\r\u0005\r\u0082\n\r\u0003\r\u0003\r',
  '\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0005\u000e\u008a\n\u000e\u0003',
  '\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000f\u0003\u000f\u0003',
  '\u000f\u0003\u000f\u0005\u000f\u0094\n\u000f\u0003\u0010\u0003\u0010',
  '\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011',
  '\u0003\u0011\u0003\u0011\u0003\u0011\u0005\u0011\u00a1\n\u0011\u0003',
  '\u0011\u0003\u0011\u0003\u0011\u0005\u0011\u00a6\n\u0011\u0003\u0012',
  '\u0003\u0012\u0003\u0013\u0003\u0013\u0003\u0014\u0003\u0014\u0007\u0014',
  '\u00ae\n\u0014\f\u0014\u000e\u0014\u00b1\u000b\u0014\u0003\u0015\u0003',
  '\u0015\u0003\u0016\u0003\u0016\u0005\u0016\u00b7\n\u0016\u0003\u0017',
  '\u0005\u0017\u00ba\n\u0017\u0003\u0017\u0006\u0017\u00bd\n\u0017\r\u0017',
  '\u000e\u0017\u00be\u0003\u0017\u0003\u0017\u0006\u0017\u00c3\n\u0017',
  '\r\u0017\u000e\u0017\u00c4\u0005\u0017\u00c7\n\u0017\u0003\u0018\u0005',
  '\u0018\u00ca\n\u0018\u0003\u0018\u0003\u0018\u0007\u0018\u00ce\n\u0018',
  '\f\u0018\u000e\u0018\u00d1\u000b\u0018\u0003\u0018\u0002\u0002\u0019',
  '\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012\u0014\u0016\u0018\u001a\u001c',
  '\u001e "$&(*,.\u0002\u0006\u0004\u0002\n\n\u001f\u001f\u0003\u0002',
  '\u000e\u000f\u0003\u0002!"\u0004\u0002\u001f\u001f!"\u0002\u00de\u0002',
  '0\u0003\u0002\u0002\u0002\u00042\u0003\u0002\u0002\u0002\u00067\u0003',
  '\u0002\u0002\u0002\bD\u0003\u0002\u0002\u0002\nN\u0003\u0002\u0002\u0002',
  '\fP\u0003\u0002\u0002\u0002\u000eY\u0003\u0002\u0002\u0002\u0010i\u0003',
  '\u0002\u0002\u0002\u0012k\u0003\u0002\u0002\u0002\u0014t\u0003\u0002',
  '\u0002\u0002\u0016x\u0003\u0002\u0002\u0002\u0018\u007f\u0003\u0002',
  '\u0002\u0002\u001a\u0087\u0003\u0002\u0002\u0002\u001c\u0093\u0003\u0002',
  '\u0002\u0002\u001e\u0095\u0003\u0002\u0002\u0002 \u00a5\u0003\u0002',
  '\u0002\u0002"\u00a7\u0003\u0002\u0002\u0002$\u00a9\u0003\u0002\u0002',
  '\u0002&\u00ab\u0003\u0002\u0002\u0002(\u00b2\u0003\u0002\u0002\u0002',
  '*\u00b6\u0003\u0002\u0002\u0002,\u00b9\u0003\u0002\u0002\u0002.\u00c9',
  '\u0003\u0002\u0002\u000201\u0005\u0004\u0003\u00021\u0003\u0003\u0002',
  '\u0002\u000223\u0007\n\u0002\u000234\u0007\u0013\u0002\u000245\u0005',
  '\u0006\u0004\u000256\u0007\u0014\u0002\u00026\u0005\u0003\u0002\u0002',
  '\u000278\u0007\u0003\u0002\u00028>\u0005\b\u0005\u00029:\u0005\n\u0006',
  '\u0002:;\u0005\b\u0005\u0002;=\u0003\u0002\u0002\u0002<9\u0003\u0002',
  '\u0002\u0002=@\u0003\u0002\u0002\u0002><\u0003\u0002\u0002\u0002>?\u0003',
  '\u0002\u0002\u0002?A\u0003\u0002\u0002\u0002@>\u0003\u0002\u0002\u0002',
  'AB\u0007\u0012\u0002\u0002B\u0007\u0003\u0002\u0002\u0002CE\u0007\u0011',
  '\u0002\u0002DC\u0003\u0002\u0002\u0002DE\u0003\u0002\u0002\u0002EF\u0003',
  '\u0002\u0002\u0002FH\u0005\f\u0007\u0002GI\u0007\u0012\u0002\u0002H',
  'G\u0003\u0002\u0002\u0002HI\u0003\u0002\u0002\u0002I\t\u0003\u0002\u0002',
  '\u0002JK\u0007%\u0002\u0002KO\u0007%\u0002\u0002LM\u0007$\u0002\u0002',
  'MO\u0007$\u0002\u0002NJ\u0003\u0002\u0002\u0002NL\u0003\u0002\u0002',
  '\u0002O\u000b\u0003\u0002\u0002\u0002PV\u0005\u000e\b\u0002QR\u0005',
  '\u001c\u000f\u0002RS\u0005\u000e\b\u0002SU\u0003\u0002\u0002\u0002T',
  'Q\u0003\u0002\u0002\u0002UX\u0003\u0002\u0002\u0002VT\u0003\u0002\u0002',
  '\u0002VW\u0003\u0002\u0002\u0002W\r\u0003\u0002\u0002\u0002XV\u0003',
  '\u0002\u0002\u0002Y]\u0005\u0010\t\u0002Z\\\u0005\u0010\t\u0002[Z\u0003',
  '\u0002\u0002\u0002\\_\u0003\u0002\u0002\u0002][\u0003\u0002\u0002\u0002',
  ']^\u0003\u0002\u0002\u0002^\u000f\u0003\u0002\u0002\u0002_]\u0003\u0002',
  '\u0002\u0002`j\u0005\u0012\n\u0002aj\u0005 \u0011\u0002bj\u0005\u0016',
  '\f\u0002cj\u0005\u0018\r\u0002dj\u0005\u001a\u000e\u0002ej\u0005(\u0015',
  '\u0002fj\u0005,\u0017\u0002gj\u0005$\u0013\u0002hj\u0005"\u0012\u0002',
  'i`\u0003\u0002\u0002\u0002ia\u0003\u0002\u0002\u0002ib\u0003\u0002\u0002',
  '\u0002ic\u0003\u0002\u0002\u0002id\u0003\u0002\u0002\u0002ie\u0003\u0002',
  '\u0002\u0002if\u0003\u0002\u0002\u0002ig\u0003\u0002\u0002\u0002ih\u0003',
  '\u0002\u0002\u0002j\u0011\u0003\u0002\u0002\u0002kl\t\u0002\u0002\u0002',
  'lq\u0005\u0014\u000b\u0002mn\u0007\u001f\u0002\u0002np\u0005\u0014\u000b',
  '\u0002om\u0003\u0002\u0002\u0002ps\u0003\u0002\u0002\u0002qo\u0003\u0002',
  '\u0002\u0002qr\u0003\u0002\u0002\u0002r\u0013\u0003\u0002\u0002\u0002',
  'sq\u0003\u0002\u0002\u0002tu\u0007\u0013\u0002\u0002uv\u0005(\u0015',
  '\u0002vw\u0007\u0014\u0002\u0002w\u0015\u0003\u0002\u0002\u0002xz\u0007',
  '\u0018\u0002\u0002y{\u0005\u001e\u0010\u0002zy\u0003\u0002\u0002\u0002',
  'z{\u0003\u0002\u0002\u0002{|\u0003\u0002\u0002\u0002|}\u0005&\u0014',
  '\u0002}~\u0007\u0004\u0002\u0002~\u0017\u0003\u0002\u0002\u0002\u007f',
  '\u0081\u0007\u0018\u0002\u0002\u0080\u0082\u0005\u001e\u0010\u0002\u0081',
  '\u0080\u0003\u0002\u0002\u0002\u0081\u0082\u0003\u0002\u0002\u0002\u0082',
  '\u0083\u0003\u0002\u0002\u0002\u0083\u0084\u0007\u0005\u0002\u0002\u0084',
  '\u0085\u0005&\u0014\u0002\u0085\u0086\u0007\u0004\u0002\u0002\u0086',
  '\u0019\u0003\u0002\u0002\u0002\u0087\u0089\u0007\u0018\u0002\u0002\u0088',
  '\u008a\u0005\u001e\u0010\u0002\u0089\u0088\u0003\u0002\u0002\u0002\u0089',
  '\u008a\u0003\u0002\u0002\u0002\u008a\u008b\u0003\u0002\u0002\u0002\u008b',
  '\u008c\u0007\u0005\u0002\u0002\u008c\u008d\u0005&\u0014\u0002\u008d',
  '\u008e\u0007\u0018\u0002\u0002\u008e\u001b\u0003\u0002\u0002\u0002\u008f',
  '\u0090\u0007%\u0002\u0002\u0090\u0094\u0007%\u0002\u0002\u0091\u0092',
  '\u0007$\u0002\u0002\u0092\u0094\u0007$\u0002\u0002\u0093\u008f\u0003',
  '\u0002\u0002\u0002\u0093\u0091\u0003\u0002\u0002\u0002\u0094\u001d\u0003',
  '\u0002\u0002\u0002\u0095\u0096\u0007\u0006\u0002\u0002\u0096\u001f\u0003',
  '\u0002\u0002\u0002\u0097\u0098\u0007\u001c\u0002\u0002\u0098\u00a6\u0007',
  '\u001c\u0002\u0002\u0099\u009a\u0007\u001b\u0002\u0002\u009a\u00a6\u0007',
  '\u001c\u0002\u0002\u009b\u00a6\u0007\u0019\u0002\u0002\u009c\u00a6\u0007',
  '\u001a\u0002\u0002\u009d\u00a6\u0007\u0007\u0002\u0002\u009e\u00a6\u0007',
  '\b\u0002\u0002\u009f\u00a1\u0007\u001b\u0002\u0002\u00a0\u009f\u0003',
  '\u0002\u0002\u0002\u00a0\u00a1\u0003\u0002\u0002\u0002\u00a1\u00a2\u0003',
  '\u0002\u0002\u0002\u00a2\u00a6\u0007\u000b\u0002\u0002\u00a3\u00a4\u0007',
  '\u001c\u0002\u0002\u00a4\u00a6\u0007\u001d\u0002\u0002\u00a5\u0097\u0003',
  '\u0002\u0002\u0002\u00a5\u0099\u0003\u0002\u0002\u0002\u00a5\u009b\u0003',
  '\u0002\u0002\u0002\u00a5\u009c\u0003\u0002\u0002\u0002\u00a5\u009d\u0003',
  '\u0002\u0002\u0002\u00a5\u009e\u0003\u0002\u0002\u0002\u00a5\u00a0\u0003',
  '\u0002\u0002\u0002\u00a5\u00a3\u0003\u0002\u0002\u0002\u00a6!\u0003',
  '\u0002\u0002\u0002\u00a7\u00a8\u0007\t\u0002\u0002\u00a8#\u0003\u0002',
  '\u0002\u0002\u00a9\u00aa\t\u0003\u0002\u0002\u00aa%\u0003\u0002\u0002',
  '\u0002\u00ab\u00af\t\u0004\u0002\u0002\u00ac\u00ae\t\u0004\u0002\u0002',
  '\u00ad\u00ac\u0003\u0002\u0002\u0002\u00ae\u00b1\u0003\u0002\u0002\u0002',
  '\u00af\u00ad\u0003\u0002\u0002\u0002\u00af\u00b0\u0003\u0002\u0002\u0002',
  "\u00b0'\u0003\u0002\u0002\u0002\u00b1\u00af\u0003\u0002\u0002\u0002",
  '\u00b2\u00b3\u0007\u0010\u0002\u0002\u00b3)\u0003\u0002\u0002\u0002',
  '\u00b4\u00b7\u0005,\u0017\u0002\u00b5\u00b7\u0005(\u0015\u0002\u00b6',
  '\u00b4\u0003\u0002\u0002\u0002\u00b6\u00b5\u0003\u0002\u0002\u0002\u00b7',
  '+\u0003\u0002\u0002\u0002\u00b8\u00ba\u0007\u0016\u0002\u0002\u00b9',
  '\u00b8\u0003\u0002\u0002\u0002\u00b9\u00ba\u0003\u0002\u0002\u0002\u00ba',
  '\u00bc\u0003\u0002\u0002\u0002\u00bb\u00bd\u0007"\u0002\u0002\u00bc',
  '\u00bb\u0003\u0002\u0002\u0002\u00bd\u00be\u0003\u0002\u0002\u0002\u00be',
  '\u00bc\u0003\u0002\u0002\u0002\u00be\u00bf\u0003\u0002\u0002\u0002\u00bf',
  '\u00c6\u0003\u0002\u0002\u0002\u00c0\u00c2\u0007\u001f\u0002\u0002\u00c1',
  '\u00c3\u0007"\u0002\u0002\u00c2\u00c1\u0003\u0002\u0002\u0002\u00c3',
  '\u00c4\u0003\u0002\u0002\u0002\u00c4\u00c2\u0003\u0002\u0002\u0002\u00c4',
  '\u00c5\u0003\u0002\u0002\u0002\u00c5\u00c7\u0003\u0002\u0002\u0002\u00c6',
  '\u00c0\u0003\u0002\u0002\u0002\u00c6\u00c7\u0003\u0002\u0002\u0002\u00c7',
  '-\u0003\u0002\u0002\u0002\u00c8\u00ca\u0007\u0016\u0002\u0002\u00c9',
  '\u00c8\u0003\u0002\u0002\u0002\u00c9\u00ca\u0003\u0002\u0002\u0002\u00ca',
  '\u00cb\u0003\u0002\u0002\u0002\u00cb\u00cf\u0007!\u0002\u0002\u00cc',
  '\u00ce\t\u0005\u0002\u0002\u00cd\u00cc\u0003\u0002\u0002\u0002\u00ce',
  '\u00d1\u0003\u0002\u0002\u0002\u00cf\u00cd\u0003\u0002\u0002\u0002\u00cf',
  '\u00d0\u0003\u0002\u0002\u0002\u00d0/\u0003\u0002\u0002\u0002\u00d1',
  '\u00cf\u0003\u0002\u0002\u0002\u0018>DHNV]iqz\u0081\u0089\u0093\u00a0',
  '\u00a5\u00af\u00b6\u00b9\u00be\u00c4\u00c6\u00c9\u00cf',
].join('');

var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.dfa.DFA(ds, index);
});

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [
  null,
  "'?('",
  "'.*/'",
  "'.*'",
  "'(?i)'",
  "'nin'",
  "'in'",
  "'null'",
  "'$.'",
  "'@'",
  "'%'",
  null,
  "'true'",
  "'false'",
  null,
  "'('",
  "')'",
  "'['",
  "']'",
  "'+'",
  "'-'",
  "'*'",
  "'/'",
  "'>'",
  "'<'",
  "'!'",
  "'='",
  "'~'",
  null,
  "'.'",
  "'^'",
  null,
  null,
  "','",
  "'|'",
  "'&'",
];

var symbolicNames = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  'PATHTOKEN',
  'ATNAME',
  'PNAME',
  'ENAME',
  'TRUE',
  'FALSE',
  'STRING',
  'LPAREN',
  'RPAREN',
  'LBRACKET',
  'RBRACKET',
  'PLUS',
  'MINUS',
  'TIMES',
  'DIV',
  'GT',
  'LT',
  'NOT',
  'EQ',
  'TILDE',
  'QM',
  'POINT',
  'CARET',
  'LETTER',
  'DIGIT',
  'COMMA',
  'PIPE',
  'AMP',
  'WS',
];

var ruleNames = [
  'filters',
  'bracketnotation',
  'bracketnotation_expr',
  'queryGroup',
  'groupJoinOp',
  'queryExpr',
  'queryRule',
  'atom',
  'pathRef',
  'attrpart',
  'regexBegin',
  'regexContains',
  'regexEnd',
  'joinOp',
  'caseParam',
  'filterOp',
  'nullValue',
  'boolValue',
  'regexValue',
  'string',
  'literal',
  'number',
  'variable',
];

function FiltersParser(input) {
  antlr4.Parser.call(this, input);
  this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
  this.ruleNames = ruleNames;
  this.literalNames = literalNames;
  this.symbolicNames = symbolicNames;
  return this;
}

FiltersParser.prototype = Object.create(antlr4.Parser.prototype);
FiltersParser.prototype.constructor = FiltersParser;

Object.defineProperty(FiltersParser.prototype, 'atn', {
  get: function () {
    return atn;
  },
});

FiltersParser.EOF = antlr4.Token.EOF;
FiltersParser.T__0 = 1;
FiltersParser.T__1 = 2;
FiltersParser.T__2 = 3;
FiltersParser.T__3 = 4;
FiltersParser.T__4 = 5;
FiltersParser.T__5 = 6;
FiltersParser.T__6 = 7;
FiltersParser.PATHTOKEN = 8;
FiltersParser.ATNAME = 9;
FiltersParser.PNAME = 10;
FiltersParser.ENAME = 11;
FiltersParser.TRUE = 12;
FiltersParser.FALSE = 13;
FiltersParser.STRING = 14;
FiltersParser.LPAREN = 15;
FiltersParser.RPAREN = 16;
FiltersParser.LBRACKET = 17;
FiltersParser.RBRACKET = 18;
FiltersParser.PLUS = 19;
FiltersParser.MINUS = 20;
FiltersParser.TIMES = 21;
FiltersParser.DIV = 22;
FiltersParser.GT = 23;
FiltersParser.LT = 24;
FiltersParser.NOT = 25;
FiltersParser.EQ = 26;
FiltersParser.TILDE = 27;
FiltersParser.QM = 28;
FiltersParser.POINT = 29;
FiltersParser.CARET = 30;
FiltersParser.LETTER = 31;
FiltersParser.DIGIT = 32;
FiltersParser.COMMA = 33;
FiltersParser.PIPE = 34;
FiltersParser.AMP = 35;
FiltersParser.WS = 36;

FiltersParser.RULE_filters = 0;
FiltersParser.RULE_bracketnotation = 1;
FiltersParser.RULE_bracketnotation_expr = 2;
FiltersParser.RULE_queryGroup = 3;
FiltersParser.RULE_groupJoinOp = 4;
FiltersParser.RULE_queryExpr = 5;
FiltersParser.RULE_queryRule = 6;
FiltersParser.RULE_atom = 7;
FiltersParser.RULE_pathRef = 8;
FiltersParser.RULE_attrpart = 9;
FiltersParser.RULE_regexBegin = 10;
FiltersParser.RULE_regexContains = 11;
FiltersParser.RULE_regexEnd = 12;
FiltersParser.RULE_joinOp = 13;
FiltersParser.RULE_caseParam = 14;
FiltersParser.RULE_filterOp = 15;
FiltersParser.RULE_nullValue = 16;
FiltersParser.RULE_boolValue = 17;
FiltersParser.RULE_regexValue = 18;
FiltersParser.RULE_string = 19;
FiltersParser.RULE_literal = 20;
FiltersParser.RULE_number = 21;
FiltersParser.RULE_variable = 22;

function FiltersContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_filters;
  return this;
}

FiltersContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FiltersContext.prototype.constructor = FiltersContext;

FiltersContext.prototype.bracketnotation = function () {
  return this.getTypedRuleContext(BracketnotationContext, 0);
};

FiltersContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterFilters(this);
  }
};

FiltersContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitFilters(this);
  }
};

FiltersParser.FiltersContext = FiltersContext;

FiltersParser.prototype.filters = function () {
  var localctx = new FiltersContext(this, this._ctx, this.state);
  this.enterRule(localctx, 0, FiltersParser.RULE_filters);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 46;
    this.bracketnotation();
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function BracketnotationContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_bracketnotation;
  return this;
}

BracketnotationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BracketnotationContext.prototype.constructor = BracketnotationContext;

BracketnotationContext.prototype.LBRACKET = function () {
  return this.getToken(FiltersParser.LBRACKET, 0);
};

BracketnotationContext.prototype.bracketnotation_expr = function () {
  return this.getTypedRuleContext(Bracketnotation_exprContext, 0);
};

BracketnotationContext.prototype.RBRACKET = function () {
  return this.getToken(FiltersParser.RBRACKET, 0);
};

BracketnotationContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterBracketnotation(this);
  }
};

BracketnotationContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitBracketnotation(this);
  }
};

FiltersParser.BracketnotationContext = BracketnotationContext;

FiltersParser.prototype.bracketnotation = function () {
  var localctx = new BracketnotationContext(this, this._ctx, this.state);
  this.enterRule(localctx, 2, FiltersParser.RULE_bracketnotation);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 48;
    this.match(FiltersParser.PATHTOKEN);
    this.state = 49;
    this.match(FiltersParser.LBRACKET);
    this.state = 50;
    this.bracketnotation_expr();
    this.state = 51;
    this.match(FiltersParser.RBRACKET);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function Bracketnotation_exprContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_bracketnotation_expr;
  return this;
}

Bracketnotation_exprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Bracketnotation_exprContext.prototype.constructor = Bracketnotation_exprContext;

Bracketnotation_exprContext.prototype.queryGroup = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(QueryGroupContext);
  } else {
    return this.getTypedRuleContext(QueryGroupContext, i);
  }
};

Bracketnotation_exprContext.prototype.groupJoinOp = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(GroupJoinOpContext);
  } else {
    return this.getTypedRuleContext(GroupJoinOpContext, i);
  }
};

Bracketnotation_exprContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterBracketnotation_expr(this);
  }
};

Bracketnotation_exprContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitBracketnotation_expr(this);
  }
};

FiltersParser.Bracketnotation_exprContext = Bracketnotation_exprContext;

FiltersParser.prototype.bracketnotation_expr = function () {
  var localctx = new Bracketnotation_exprContext(this, this._ctx, this.state);
  this.enterRule(localctx, 4, FiltersParser.RULE_bracketnotation_expr);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 53;
    this.match(FiltersParser.T__0);
    this.state = 54;
    this.queryGroup();
    this.state = 60;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    while (_la === FiltersParser.PIPE || _la === FiltersParser.AMP) {
      this.state = 55;
      this.groupJoinOp();
      this.state = 56;
      this.queryGroup();
      this.state = 62;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    }
    this.state = 63;
    this.match(FiltersParser.RPAREN);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function QueryGroupContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_queryGroup;
  return this;
}

QueryGroupContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
QueryGroupContext.prototype.constructor = QueryGroupContext;

QueryGroupContext.prototype.queryExpr = function () {
  return this.getTypedRuleContext(QueryExprContext, 0);
};

QueryGroupContext.prototype.LPAREN = function () {
  return this.getToken(FiltersParser.LPAREN, 0);
};

QueryGroupContext.prototype.RPAREN = function () {
  return this.getToken(FiltersParser.RPAREN, 0);
};

QueryGroupContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterQueryGroup(this);
  }
};

QueryGroupContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitQueryGroup(this);
  }
};

FiltersParser.QueryGroupContext = QueryGroupContext;

FiltersParser.prototype.queryGroup = function () {
  var localctx = new QueryGroupContext(this, this._ctx, this.state);
  this.enterRule(localctx, 6, FiltersParser.RULE_queryGroup);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 66;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === FiltersParser.LPAREN) {
      this.state = 65;
      this.match(FiltersParser.LPAREN);
    }

    this.state = 68;
    this.queryExpr();
    this.state = 70;
    this._errHandler.sync(this);
    var la_ = this._interp.adaptivePredict(this._input, 2, this._ctx);
    if (la_ === 1) {
      this.state = 69;
      this.match(FiltersParser.RPAREN);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function GroupJoinOpContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_groupJoinOp;
  return this;
}

GroupJoinOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
GroupJoinOpContext.prototype.constructor = GroupJoinOpContext;

GroupJoinOpContext.prototype.AMP = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.AMP);
  } else {
    return this.getToken(FiltersParser.AMP, i);
  }
};

GroupJoinOpContext.prototype.PIPE = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.PIPE);
  } else {
    return this.getToken(FiltersParser.PIPE, i);
  }
};

GroupJoinOpContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterGroupJoinOp(this);
  }
};

GroupJoinOpContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitGroupJoinOp(this);
  }
};

FiltersParser.GroupJoinOpContext = GroupJoinOpContext;

FiltersParser.prototype.groupJoinOp = function () {
  var localctx = new GroupJoinOpContext(this, this._ctx, this.state);
  this.enterRule(localctx, 8, FiltersParser.RULE_groupJoinOp);
  try {
    this.state = 76;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case FiltersParser.AMP:
        this.enterOuterAlt(localctx, 1);
        this.state = 72;
        this.match(FiltersParser.AMP);
        this.state = 73;
        this.match(FiltersParser.AMP);
        break;
      case FiltersParser.PIPE:
        this.enterOuterAlt(localctx, 2);
        this.state = 74;
        this.match(FiltersParser.PIPE);
        this.state = 75;
        this.match(FiltersParser.PIPE);
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function QueryExprContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_queryExpr;
  return this;
}

QueryExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
QueryExprContext.prototype.constructor = QueryExprContext;

QueryExprContext.prototype.queryRule = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(QueryRuleContext);
  } else {
    return this.getTypedRuleContext(QueryRuleContext, i);
  }
};

QueryExprContext.prototype.joinOp = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(JoinOpContext);
  } else {
    return this.getTypedRuleContext(JoinOpContext, i);
  }
};

QueryExprContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterQueryExpr(this);
  }
};

QueryExprContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitQueryExpr(this);
  }
};

FiltersParser.QueryExprContext = QueryExprContext;

FiltersParser.prototype.queryExpr = function () {
  var localctx = new QueryExprContext(this, this._ctx, this.state);
  this.enterRule(localctx, 10, FiltersParser.RULE_queryExpr);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 78;
    this.queryRule();
    this.state = 84;
    this._errHandler.sync(this);
    var _alt = this._interp.adaptivePredict(this._input, 4, this._ctx);
    while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
      if (_alt === 1) {
        this.state = 79;
        this.joinOp();
        this.state = 80;
        this.queryRule();
      }
      this.state = 86;
      this._errHandler.sync(this);
      _alt = this._interp.adaptivePredict(this._input, 4, this._ctx);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function QueryRuleContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_queryRule;
  return this;
}

QueryRuleContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
QueryRuleContext.prototype.constructor = QueryRuleContext;

QueryRuleContext.prototype.atom = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(AtomContext);
  } else {
    return this.getTypedRuleContext(AtomContext, i);
  }
};

QueryRuleContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterQueryRule(this);
  }
};

QueryRuleContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitQueryRule(this);
  }
};

FiltersParser.QueryRuleContext = QueryRuleContext;

FiltersParser.prototype.queryRule = function () {
  var localctx = new QueryRuleContext(this, this._ctx, this.state);
  this.enterRule(localctx, 12, FiltersParser.RULE_queryRule);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 87;
    this.atom();
    this.state = 91;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    while (
      ((_la - 5) & ~0x1f) == 0 &&
      ((1 << (_la - 5)) &
        ((1 << (FiltersParser.T__4 - 5)) |
          (1 << (FiltersParser.T__5 - 5)) |
          (1 << (FiltersParser.T__6 - 5)) |
          (1 << (FiltersParser.PATHTOKEN - 5)) |
          (1 << (FiltersParser.ATNAME - 5)) |
          (1 << (FiltersParser.TRUE - 5)) |
          (1 << (FiltersParser.FALSE - 5)) |
          (1 << (FiltersParser.STRING - 5)) |
          (1 << (FiltersParser.MINUS - 5)) |
          (1 << (FiltersParser.DIV - 5)) |
          (1 << (FiltersParser.GT - 5)) |
          (1 << (FiltersParser.LT - 5)) |
          (1 << (FiltersParser.NOT - 5)) |
          (1 << (FiltersParser.EQ - 5)) |
          (1 << (FiltersParser.POINT - 5)) |
          (1 << (FiltersParser.DIGIT - 5)))) !==
        0
    ) {
      this.state = 88;
      this.atom();
      this.state = 93;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function AtomContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_atom;
  return this;
}

AtomContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AtomContext.prototype.constructor = AtomContext;

AtomContext.prototype.pathRef = function () {
  return this.getTypedRuleContext(PathRefContext, 0);
};

AtomContext.prototype.filterOp = function () {
  return this.getTypedRuleContext(FilterOpContext, 0);
};

AtomContext.prototype.regexBegin = function () {
  return this.getTypedRuleContext(RegexBeginContext, 0);
};

AtomContext.prototype.regexContains = function () {
  return this.getTypedRuleContext(RegexContainsContext, 0);
};

AtomContext.prototype.regexEnd = function () {
  return this.getTypedRuleContext(RegexEndContext, 0);
};

AtomContext.prototype.string = function () {
  return this.getTypedRuleContext(StringContext, 0);
};

AtomContext.prototype.number = function () {
  return this.getTypedRuleContext(NumberContext, 0);
};

AtomContext.prototype.boolValue = function () {
  return this.getTypedRuleContext(BoolValueContext, 0);
};

AtomContext.prototype.nullValue = function () {
  return this.getTypedRuleContext(NullValueContext, 0);
};

AtomContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterAtom(this);
  }
};

AtomContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitAtom(this);
  }
};

FiltersParser.AtomContext = AtomContext;

FiltersParser.prototype.atom = function () {
  var localctx = new AtomContext(this, this._ctx, this.state);
  this.enterRule(localctx, 14, FiltersParser.RULE_atom);
  try {
    this.state = 103;
    this._errHandler.sync(this);
    var la_ = this._interp.adaptivePredict(this._input, 6, this._ctx);
    switch (la_) {
      case 1:
        this.enterOuterAlt(localctx, 1);
        this.state = 94;
        this.pathRef();
        break;

      case 2:
        this.enterOuterAlt(localctx, 2);
        this.state = 95;
        this.filterOp();
        break;

      case 3:
        this.enterOuterAlt(localctx, 3);
        this.state = 96;
        this.regexBegin();
        break;

      case 4:
        this.enterOuterAlt(localctx, 4);
        this.state = 97;
        this.regexContains();
        break;

      case 5:
        this.enterOuterAlt(localctx, 5);
        this.state = 98;
        this.regexEnd();
        break;

      case 6:
        this.enterOuterAlt(localctx, 6);
        this.state = 99;
        this.string();
        break;

      case 7:
        this.enterOuterAlt(localctx, 7);
        this.state = 100;
        this.number();
        break;

      case 8:
        this.enterOuterAlt(localctx, 8);
        this.state = 101;
        this.boolValue();
        break;

      case 9:
        this.enterOuterAlt(localctx, 9);
        this.state = 102;
        this.nullValue();
        break;
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function PathRefContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_pathRef;
  return this;
}

PathRefContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PathRefContext.prototype.constructor = PathRefContext;

PathRefContext.prototype.attrpart = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(AttrpartContext);
  } else {
    return this.getTypedRuleContext(AttrpartContext, i);
  }
};

PathRefContext.prototype.PATHTOKEN = function () {
  return this.getToken(FiltersParser.PATHTOKEN, 0);
};

PathRefContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterPathRef(this);
  }
};

PathRefContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitPathRef(this);
  }
};

FiltersParser.PathRefContext = PathRefContext;

FiltersParser.prototype.pathRef = function () {
  var localctx = new PathRefContext(this, this._ctx, this.state);
  this.enterRule(localctx, 16, FiltersParser.RULE_pathRef);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 105;
    _la = this._input.LA(1);
    if (!(_la === FiltersParser.PATHTOKEN || _la === FiltersParser.POINT)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 106;
    this.attrpart();
    this.state = 111;
    this._errHandler.sync(this);
    var _alt = this._interp.adaptivePredict(this._input, 7, this._ctx);
    while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
      if (_alt === 1) {
        this.state = 107;
        this.match(FiltersParser.POINT);
        this.state = 108;
        this.attrpart();
      }
      this.state = 113;
      this._errHandler.sync(this);
      _alt = this._interp.adaptivePredict(this._input, 7, this._ctx);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function AttrpartContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_attrpart;
  return this;
}

AttrpartContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AttrpartContext.prototype.constructor = AttrpartContext;

AttrpartContext.prototype.LBRACKET = function () {
  return this.getToken(FiltersParser.LBRACKET, 0);
};

AttrpartContext.prototype.string = function () {
  return this.getTypedRuleContext(StringContext, 0);
};

AttrpartContext.prototype.RBRACKET = function () {
  return this.getToken(FiltersParser.RBRACKET, 0);
};

AttrpartContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterAttrpart(this);
  }
};

AttrpartContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitAttrpart(this);
  }
};

FiltersParser.AttrpartContext = AttrpartContext;

FiltersParser.prototype.attrpart = function () {
  var localctx = new AttrpartContext(this, this._ctx, this.state);
  this.enterRule(localctx, 18, FiltersParser.RULE_attrpart);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 114;
    this.match(FiltersParser.LBRACKET);
    this.state = 115;
    this.string();
    this.state = 116;
    this.match(FiltersParser.RBRACKET);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function RegexBeginContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_regexBegin;
  return this;
}

RegexBeginContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RegexBeginContext.prototype.constructor = RegexBeginContext;

RegexBeginContext.prototype.regexValue = function () {
  return this.getTypedRuleContext(RegexValueContext, 0);
};

RegexBeginContext.prototype.caseParam = function () {
  return this.getTypedRuleContext(CaseParamContext, 0);
};

RegexBeginContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterRegexBegin(this);
  }
};

RegexBeginContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitRegexBegin(this);
  }
};

FiltersParser.RegexBeginContext = RegexBeginContext;

FiltersParser.prototype.regexBegin = function () {
  var localctx = new RegexBeginContext(this, this._ctx, this.state);
  this.enterRule(localctx, 20, FiltersParser.RULE_regexBegin);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 118;
    this.match(FiltersParser.DIV);
    this.state = 120;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === FiltersParser.T__3) {
      this.state = 119;
      this.caseParam();
    }

    this.state = 122;
    this.regexValue();
    this.state = 123;
    this.match(FiltersParser.T__1);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function RegexContainsContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_regexContains;
  return this;
}

RegexContainsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RegexContainsContext.prototype.constructor = RegexContainsContext;

RegexContainsContext.prototype.regexValue = function () {
  return this.getTypedRuleContext(RegexValueContext, 0);
};

RegexContainsContext.prototype.caseParam = function () {
  return this.getTypedRuleContext(CaseParamContext, 0);
};

RegexContainsContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterRegexContains(this);
  }
};

RegexContainsContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitRegexContains(this);
  }
};

FiltersParser.RegexContainsContext = RegexContainsContext;

FiltersParser.prototype.regexContains = function () {
  var localctx = new RegexContainsContext(this, this._ctx, this.state);
  this.enterRule(localctx, 22, FiltersParser.RULE_regexContains);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 125;
    this.match(FiltersParser.DIV);
    this.state = 127;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === FiltersParser.T__3) {
      this.state = 126;
      this.caseParam();
    }

    this.state = 129;
    this.match(FiltersParser.T__2);
    this.state = 130;
    this.regexValue();
    this.state = 131;
    this.match(FiltersParser.T__1);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function RegexEndContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_regexEnd;
  return this;
}

RegexEndContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RegexEndContext.prototype.constructor = RegexEndContext;

RegexEndContext.prototype.regexValue = function () {
  return this.getTypedRuleContext(RegexValueContext, 0);
};

RegexEndContext.prototype.caseParam = function () {
  return this.getTypedRuleContext(CaseParamContext, 0);
};

RegexEndContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterRegexEnd(this);
  }
};

RegexEndContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitRegexEnd(this);
  }
};

FiltersParser.RegexEndContext = RegexEndContext;

FiltersParser.prototype.regexEnd = function () {
  var localctx = new RegexEndContext(this, this._ctx, this.state);
  this.enterRule(localctx, 24, FiltersParser.RULE_regexEnd);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 133;
    this.match(FiltersParser.DIV);
    this.state = 135;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === FiltersParser.T__3) {
      this.state = 134;
      this.caseParam();
    }

    this.state = 137;
    this.match(FiltersParser.T__2);
    this.state = 138;
    this.regexValue();
    this.state = 139;
    this.match(FiltersParser.DIV);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function JoinOpContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_joinOp;
  return this;
}

JoinOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
JoinOpContext.prototype.constructor = JoinOpContext;

JoinOpContext.prototype.AMP = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.AMP);
  } else {
    return this.getToken(FiltersParser.AMP, i);
  }
};

JoinOpContext.prototype.PIPE = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.PIPE);
  } else {
    return this.getToken(FiltersParser.PIPE, i);
  }
};

JoinOpContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterJoinOp(this);
  }
};

JoinOpContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitJoinOp(this);
  }
};

FiltersParser.JoinOpContext = JoinOpContext;

FiltersParser.prototype.joinOp = function () {
  var localctx = new JoinOpContext(this, this._ctx, this.state);
  this.enterRule(localctx, 26, FiltersParser.RULE_joinOp);
  try {
    this.state = 145;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case FiltersParser.AMP:
        this.enterOuterAlt(localctx, 1);
        this.state = 141;
        this.match(FiltersParser.AMP);
        this.state = 142;
        this.match(FiltersParser.AMP);
        break;
      case FiltersParser.PIPE:
        this.enterOuterAlt(localctx, 2);
        this.state = 143;
        this.match(FiltersParser.PIPE);
        this.state = 144;
        this.match(FiltersParser.PIPE);
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function CaseParamContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_caseParam;
  return this;
}

CaseParamContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CaseParamContext.prototype.constructor = CaseParamContext;

CaseParamContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterCaseParam(this);
  }
};

CaseParamContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitCaseParam(this);
  }
};

FiltersParser.CaseParamContext = CaseParamContext;

FiltersParser.prototype.caseParam = function () {
  var localctx = new CaseParamContext(this, this._ctx, this.state);
  this.enterRule(localctx, 28, FiltersParser.RULE_caseParam);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 147;
    this.match(FiltersParser.T__3);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function FilterOpContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_filterOp;
  return this;
}

FilterOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FilterOpContext.prototype.constructor = FilterOpContext;

FilterOpContext.prototype.EQ = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.EQ);
  } else {
    return this.getToken(FiltersParser.EQ, i);
  }
};

FilterOpContext.prototype.NOT = function () {
  return this.getToken(FiltersParser.NOT, 0);
};

FilterOpContext.prototype.GT = function () {
  return this.getToken(FiltersParser.GT, 0);
};

FilterOpContext.prototype.LT = function () {
  return this.getToken(FiltersParser.LT, 0);
};

FilterOpContext.prototype.ATNAME = function () {
  return this.getToken(FiltersParser.ATNAME, 0);
};

FilterOpContext.prototype.TILDE = function () {
  return this.getToken(FiltersParser.TILDE, 0);
};

FilterOpContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterFilterOp(this);
  }
};

FilterOpContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitFilterOp(this);
  }
};

FiltersParser.FilterOpContext = FilterOpContext;

FiltersParser.prototype.filterOp = function () {
  var localctx = new FilterOpContext(this, this._ctx, this.state);
  this.enterRule(localctx, 30, FiltersParser.RULE_filterOp);
  var _la = 0; // Token type
  try {
    this.state = 163;
    this._errHandler.sync(this);
    var la_ = this._interp.adaptivePredict(this._input, 13, this._ctx);
    switch (la_) {
      case 1:
        this.enterOuterAlt(localctx, 1);
        this.state = 149;
        this.match(FiltersParser.EQ);
        this.state = 150;
        this.match(FiltersParser.EQ);
        break;

      case 2:
        this.enterOuterAlt(localctx, 2);
        this.state = 151;
        this.match(FiltersParser.NOT);
        this.state = 152;
        this.match(FiltersParser.EQ);
        break;

      case 3:
        this.enterOuterAlt(localctx, 3);
        this.state = 153;
        this.match(FiltersParser.GT);
        break;

      case 4:
        this.enterOuterAlt(localctx, 4);
        this.state = 154;
        this.match(FiltersParser.LT);
        break;

      case 5:
        this.enterOuterAlt(localctx, 5);
        this.state = 155;
        this.match(FiltersParser.T__4);
        break;

      case 6:
        this.enterOuterAlt(localctx, 6);
        this.state = 156;
        this.match(FiltersParser.T__5);
        break;

      case 7:
        this.enterOuterAlt(localctx, 7);
        this.state = 158;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === FiltersParser.NOT) {
          this.state = 157;
          this.match(FiltersParser.NOT);
        }

        this.state = 160;
        this.match(FiltersParser.ATNAME);
        break;

      case 8:
        this.enterOuterAlt(localctx, 8);
        this.state = 161;
        this.match(FiltersParser.EQ);
        this.state = 162;
        this.match(FiltersParser.TILDE);
        break;
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function NullValueContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_nullValue;
  return this;
}

NullValueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NullValueContext.prototype.constructor = NullValueContext;

NullValueContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterNullValue(this);
  }
};

NullValueContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitNullValue(this);
  }
};

FiltersParser.NullValueContext = NullValueContext;

FiltersParser.prototype.nullValue = function () {
  var localctx = new NullValueContext(this, this._ctx, this.state);
  this.enterRule(localctx, 32, FiltersParser.RULE_nullValue);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 165;
    this.match(FiltersParser.T__6);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function BoolValueContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_boolValue;
  return this;
}

BoolValueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BoolValueContext.prototype.constructor = BoolValueContext;

BoolValueContext.prototype.TRUE = function () {
  return this.getToken(FiltersParser.TRUE, 0);
};

BoolValueContext.prototype.FALSE = function () {
  return this.getToken(FiltersParser.FALSE, 0);
};

BoolValueContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterBoolValue(this);
  }
};

BoolValueContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitBoolValue(this);
  }
};

FiltersParser.BoolValueContext = BoolValueContext;

FiltersParser.prototype.boolValue = function () {
  var localctx = new BoolValueContext(this, this._ctx, this.state);
  this.enterRule(localctx, 34, FiltersParser.RULE_boolValue);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 167;
    _la = this._input.LA(1);
    if (!(_la === FiltersParser.TRUE || _la === FiltersParser.FALSE)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function RegexValueContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_regexValue;
  return this;
}

RegexValueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RegexValueContext.prototype.constructor = RegexValueContext;

RegexValueContext.prototype.LETTER = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.LETTER);
  } else {
    return this.getToken(FiltersParser.LETTER, i);
  }
};

RegexValueContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.DIGIT);
  } else {
    return this.getToken(FiltersParser.DIGIT, i);
  }
};

RegexValueContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterRegexValue(this);
  }
};

RegexValueContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitRegexValue(this);
  }
};

FiltersParser.RegexValueContext = RegexValueContext;

FiltersParser.prototype.regexValue = function () {
  var localctx = new RegexValueContext(this, this._ctx, this.state);
  this.enterRule(localctx, 36, FiltersParser.RULE_regexValue);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 169;
    _la = this._input.LA(1);
    if (!(_la === FiltersParser.LETTER || _la === FiltersParser.DIGIT)) {
      this._errHandler.recoverInline(this);
    } else {
      this._errHandler.reportMatch(this);
      this.consume();
    }
    this.state = 173;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    while (_la === FiltersParser.LETTER || _la === FiltersParser.DIGIT) {
      this.state = 170;
      _la = this._input.LA(1);
      if (!(_la === FiltersParser.LETTER || _la === FiltersParser.DIGIT)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
      this.state = 175;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function StringContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_string;
  return this;
}

StringContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
StringContext.prototype.constructor = StringContext;

StringContext.prototype.STRING = function () {
  return this.getToken(FiltersParser.STRING, 0);
};

StringContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterString(this);
  }
};

StringContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitString(this);
  }
};

FiltersParser.StringContext = StringContext;

FiltersParser.prototype.string = function () {
  var localctx = new StringContext(this, this._ctx, this.state);
  this.enterRule(localctx, 38, FiltersParser.RULE_string);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 176;
    this.match(FiltersParser.STRING);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function LiteralContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_literal;
  return this;
}

LiteralContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralContext.prototype.constructor = LiteralContext;

LiteralContext.prototype.number = function () {
  return this.getTypedRuleContext(NumberContext, 0);
};

LiteralContext.prototype.string = function () {
  return this.getTypedRuleContext(StringContext, 0);
};

LiteralContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterLiteral(this);
  }
};

LiteralContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitLiteral(this);
  }
};

FiltersParser.LiteralContext = LiteralContext;

FiltersParser.prototype.literal = function () {
  var localctx = new LiteralContext(this, this._ctx, this.state);
  this.enterRule(localctx, 40, FiltersParser.RULE_literal);
  try {
    this.state = 180;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case FiltersParser.MINUS:
      case FiltersParser.DIGIT:
        this.enterOuterAlt(localctx, 1);
        this.state = 178;
        this.number();
        break;
      case FiltersParser.STRING:
        this.enterOuterAlt(localctx, 2);
        this.state = 179;
        this.string();
        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function NumberContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_number;
  return this;
}

NumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NumberContext.prototype.constructor = NumberContext;

NumberContext.prototype.MINUS = function () {
  return this.getToken(FiltersParser.MINUS, 0);
};

NumberContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.DIGIT);
  } else {
    return this.getToken(FiltersParser.DIGIT, i);
  }
};

NumberContext.prototype.POINT = function () {
  return this.getToken(FiltersParser.POINT, 0);
};

NumberContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterNumber(this);
  }
};

NumberContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitNumber(this);
  }
};

FiltersParser.NumberContext = NumberContext;

FiltersParser.prototype.number = function () {
  var localctx = new NumberContext(this, this._ctx, this.state);
  this.enterRule(localctx, 42, FiltersParser.RULE_number);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 183;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === FiltersParser.MINUS) {
      this.state = 182;
      this.match(FiltersParser.MINUS);
    }

    this.state = 186;
    this._errHandler.sync(this);
    var _alt = 1;
    do {
      switch (_alt) {
        case 1:
          this.state = 185;
          this.match(FiltersParser.DIGIT);
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
      this.state = 188;
      this._errHandler.sync(this);
      _alt = this._interp.adaptivePredict(this._input, 17, this._ctx);
    } while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER);
    this.state = 196;
    this._errHandler.sync(this);
    var la_ = this._interp.adaptivePredict(this._input, 19, this._ctx);
    if (la_ === 1) {
      this.state = 190;
      this.match(FiltersParser.POINT);
      this.state = 192;
      this._errHandler.sync(this);
      var _alt = 1;
      do {
        switch (_alt) {
          case 1:
            this.state = 191;
            this.match(FiltersParser.DIGIT);
            break;
          default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this.state = 194;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 18, this._ctx);
      } while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function VariableContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = FiltersParser.RULE_variable;
  return this;
}

VariableContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
VariableContext.prototype.constructor = VariableContext;

VariableContext.prototype.LETTER = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.LETTER);
  } else {
    return this.getToken(FiltersParser.LETTER, i);
  }
};

VariableContext.prototype.MINUS = function () {
  return this.getToken(FiltersParser.MINUS, 0);
};

VariableContext.prototype.DIGIT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.DIGIT);
  } else {
    return this.getToken(FiltersParser.DIGIT, i);
  }
};

VariableContext.prototype.POINT = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTokens(FiltersParser.POINT);
  } else {
    return this.getToken(FiltersParser.POINT, i);
  }
};

VariableContext.prototype.enterRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.enterVariable(this);
  }
};

VariableContext.prototype.exitRule = function (listener) {
  if (listener instanceof FiltersListener) {
    listener.exitVariable(this);
  }
};

FiltersParser.VariableContext = VariableContext;

FiltersParser.prototype.variable = function () {
  var localctx = new VariableContext(this, this._ctx, this.state);
  this.enterRule(localctx, 44, FiltersParser.RULE_variable);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 199;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === FiltersParser.MINUS) {
      this.state = 198;
      this.match(FiltersParser.MINUS);
    }

    this.state = 201;
    this.match(FiltersParser.LETTER);
    this.state = 205;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    while (
      ((_la - 29) & ~0x1f) == 0 &&
      ((1 << (_la - 29)) &
        ((1 << (FiltersParser.POINT - 29)) |
          (1 << (FiltersParser.LETTER - 29)) |
          (1 << (FiltersParser.DIGIT - 29)))) !==
        0
    ) {
      this.state = 202;
      _la = this._input.LA(1);
      if (
        !(
          ((_la - 29) & ~0x1f) == 0 &&
          ((1 << (_la - 29)) &
            ((1 << (FiltersParser.POINT - 29)) |
              (1 << (FiltersParser.LETTER - 29)) |
              (1 << (FiltersParser.DIGIT - 29)))) !==
            0
        )
      ) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
      this.state = 207;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

exports.FiltersParser = FiltersParser;
